import { observer } from 'mobx-react-lite';

import { useStore } from '@/models/root-store';

const CartNumber: React.FC = observer(() => {
  const {
    cartStore: { cart },
  } = useStore();
  const { numberOfItems } = cart;

  return (
    <span className="flex h-[17px] w-[17px] -translate-x-2 -translate-y-2 items-center justify-center rounded-full bg-primary p-0.5 pt-[3px] text-center font-interMedium text-xxs leading-none">
      {numberOfItems || 0}
    </span>
  );
});

export default CartNumber;
